import { useLicensePlateTypes } from '../queries';
import { useFleet } from './useFleet';

const DEFAULT_LICENSE_PLATE_TYPE_ID = 1;

export const useRequiresPlateType = () => {
  const fleet = useFleet();

  const fleetRequiresPlateType = Boolean(
    fleet.config?.feature_config?.is_license_plate_type_required,
  );

  return fleetRequiresPlateType;
};

export const useDefaultPlateTypeId = () => {
  // TODO maybe move this to fleet config?
  const enabled = useRequiresPlateType();
  const { data: licensePlateTypes } = useLicensePlateTypes(enabled);

  return licensePlateTypes?.[0].id ?? DEFAULT_LICENSE_PLATE_TYPE_ID;
};
